export default {
    state: {
        huTaxInfo: {
            'LOGIN': '',
            'PASS': '',
            'XML_SIG': '',
            'XML_EXCH': ''
        }
    },
    getters: {
        huTaxInfo: state => {
            return state.huTaxInfo;
        }
    },
    mutations: {
        updateHUTaxInfo: (state, payload) => {
            state.huTaxInfo = payload;
        },
        updateSigKey: (state, payload) => {
            state.huTaxInfo.XML_SIG = payload;
        }
    },
    actions: {
        updateHUTaxInfo: ({ commit }, payload) => {
            commit('updateHUTaxInfo', payload);
        },
        updateSigKey: ({ commit }, payload) => {
            commit('updateSigKey', payload);
        }
    }
}
